export enum GlobalStateKeyEnum {
  App = 'App',
  ChannelPreference = 'ChannelPreference',
  CenterDialog = 'CenterDialog',
  Contact = 'Contact',
  Coverage = 'Coverage',
  CurrentCall = 'CurrentCall',
  DirtyNavigation = 'DirtyNavigation',
  EditDetails = 'EditDetails',
  Error = 'Error',
  FeatureFlag = 'FeatureFlag',
  Impersonation = 'Impersonation',
  MissingDispositions = 'MissingDispositions',
  Payment = 'Payment',
  PaymentForm = 'PaymentForm',
  SidebarDialog = 'SidebarDialog',
  Softphone = 'Softphone',
  SoftphoneInitialized = 'SoftphoneInitialized',
  TabManager = 'TabManager',
  Toast = 'Toast',
  VerifyDetails = 'VerifyDetails',
  AdjustmentUsageAndModifications = 'AdjustmentUsageAndModifications',
}
